import { useTranslation } from "react-i18next";
import { useQueryClient } from "@tanstack/react-query";
import { GeneralButton, Modal } from "../../../components";
import { EndPoints } from "../../../Constants/endpoints";
import { usePostData } from "../../../hooks"; 
import { useToast } from "../../../Services/ToastContext";

interface DeletePriceProps {
  isModalOpen: boolean;
  closeModal: () => void;
}

function DeletePrice({ isModalOpen, closeModal }: DeletePriceProps) {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const { showToast } = useToast();

  const { mutate, isPending } = usePostData(EndPoints.EditPrice);

  const handleDelete = () => {
    mutate(
      {},
      {
        onSuccess: () => {
          showToast(t("deleted_successfully"), "success");
          queryClient.invalidateQueries({
            queryKey: [EndPoints.GetPrice],
          });
          queryClient.invalidateQueries({
            queryKey: [EndPoints.GetPersonalInfo],
          });
          closeModal();
        },
        onError: () => {
          showToast(t("delete_failed"), "error");
        },
      },
    );
  };

  return (
    <div>
      <Modal
        header={t("delete_session_price")}
        isOpen={isModalOpen}
        onClose={closeModal} 
      >
        <p className="text-secondaryDark">
          {t("are_you_sure_want_to_delete_session_price")}
        </p>
        <div className="mt-5 flex max-w-md gap-2 self-end">
          <GeneralButton
            title={t("cancel")}
            color="lite"
            onClick={closeModal}
          />
          <GeneralButton
            type="submit"
            title={t("delete")}
            color="red"
            onClick={handleDelete}
            isLoading={isPending}
          />
        </div>
      </Modal>
    </div>
  );
}

export default DeletePrice;
